import { NAV_BY_ID, type RouteId } from '@features/_navigation';
import { Icon } from '@shared/icons';

interface Props {
  readonly routeId: RouteId;
}

/**
 * Single placeholder for any not-yet-implemented route. Replaced as each
 * feature is built in Phases 4–5. Keeps the layout, breadcrumb, and a11y
 * landmarks consistent across the whole shell during the rebuild.
 */
export function PlaceholderPage({ routeId }: Props): JSX.Element {
  const item = NAV_BY_ID[routeId];
  return (
    <article>
      <header style={{ marginBottom: 'var(--sp-5)' }}>
        <p
          style={{
            fontFamily: 'var(--font-mono)',
            fontSize: 'var(--fs-10)',
            letterSpacing: '0.18em',
            color: 'var(--pfl-magenta-bright)',
            margin: 0,
          }}
        >
          {item.label.toUpperCase()}
        </p>
        <h1 style={{ margin: '6px 0 4px', fontSize: 'var(--fs-24)', fontWeight: 500 }}>
          {item.label}
        </h1>
        {item.description !== undefined ? (
          <p style={{ color: 'var(--pfl-text-mute)', margin: 0 }}>{item.description}</p>
        ) : null}
      </header>
      <section
        style={{
          border: '1px dashed var(--pfl-line)',
          borderRadius: 'var(--r-3)',
          padding: 'var(--sp-7)',
          background: 'var(--pfl-bg-panel)',
          display: 'flex',
          alignItems: 'center',
          gap: 'var(--sp-4)',
        }}
      >
        <span
          style={{
            width: 36,
            height: 36,
            display: 'grid',
            placeItems: 'center',
            background: 'rgba(232,60,227,0.08)',
            color: 'var(--pfl-magenta-bright)',
            borderRadius: 'var(--r-3)',
            border: '1px solid rgba(232,60,227,0.3)',
          }}
          aria-hidden="true"
        >
          <Icon name={item.icon} size={18} />
        </span>
        <div>
          <p style={{ margin: 0, fontWeight: 500 }}>
            <span aria-hidden="true">●</span> Coming in a later phase
          </p>
          <p style={{ margin: '4px 0 0', color: 'var(--pfl-text-mute)', fontSize: 'var(--fs-12)' }}>
            Foundation complete · feature implementation lands in Phase 4 / 5.
          </p>
        </div>
      </section>
    </article>
  );
}
